import React from 'react';
import { motion } from 'framer-motion';

interface MobileNavProps {
    activePage: string;
    onNavigate: (page: string) => void;
}

const navItems = [
    {
        id: 'dashboard',
        label: 'Обзор',
        icon: (
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <rect x="3" y="3" width="7" height="7" rx="1"/>
                <rect x="14" y="3" width="7" height="7" rx="1"/>
                <rect x="14" y="14" width="7" height="7" rx="1"/>
                <rect x="3" y="14" width="7" height="7" rx="1"/>
            </svg>
        )
    },
    {
        id: 'balances',
        label: 'Остатки',
        icon: (
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"/>
                <path d="M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8h16z"/>
            </svg>
        )
    },
    {
        id: 'incidents',
        label: 'Сбои',
        icon: (
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/>
            </svg>
        )
    },
    {
        id: 'messages',
        label: 'Уведомления',
        icon: (
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
        )
    }
];

export const MobileNav: React.FC<MobileNavProps> = ({ activePage, onNavigate }) => {
    return (
        <nav className="fixed bottom-0 left-0 right-0 h-16 pb-[env(safe-area-inset-bottom,0px)] bg-[var(--bg-elevated)] border-t border-[var(--border)] z-40 flex md:hidden">
            {navItems.map(item => {
                const isActive = activePage === item.id;
                return (
                    <motion.a
                        key={item.id}
                        onClick={() => onNavigate(item.id)}
                        className={`
                            flex-1 flex flex-col items-center justify-center gap-1 text-[10px] cursor-pointer relative
                            ${isActive ? 'text-[var(--brand)]' : 'text-[var(--text-muted)]'}
                        `}
                        whileTap={{ scale: 0.95 }}
                    >
                        {item.icon}
                        <span>{item.label}</span>
                        {isActive && (
                            <motion.div
                                layoutId="mobileNavIndicator"
                                className="absolute bottom-1 w-1 h-1 rounded-full bg-[var(--brand)]"
                            />
                        )}
                    </motion.a>
                );
            })}
        </nav>
    );
};